import { FC, useEffect } from 'react';

import { getStaticPrefix } from '@eneco/common/env';
import useDC from '@eneco/dc/useDC';
import { I18nProvider, useTranslation } from '@eneco/i18n';
import { Skeleton } from '@eneco/sparky';
import { useTracking } from '@eneco/tracking';

import { useMeterReadingsFlow } from '../../../../state/MeterReadingsFlow.machine';
import { Steps } from '../../../../tracking';
import { Amount } from '../../../templates/Amount';

export const PeriodicPayBackTermAmount: FC = () => {
  const { label } = useDC();

  return (
    <I18nProvider dictionary={locale => import(`./content/PeriodicPayBackTermAmount.${label}.${locale}.json`)}>
      <PeriodicPayBackTermAmountComponent />
    </I18nProvider>
  );
};

export const PeriodicPayBackTermAmountComponent: FC = () => {
  const { label } = useDC();
  const { t, isLoading } = useTranslation();
  const { trackFunnelCompleted } = useTracking();
  const { state } = useMeterReadingsFlow();

  useEffect(() => {
    trackFunnelCompleted({
      step: Steps['THANK_YOU.PeriodicPayBackTermAmount'],
      funnel: state.context.funnelName,
    });
  }, [state.context.funnelName, trackFunnelCompleted]);

  if (isLoading) return <Skeleton height={450} />;

  return (
    <Amount
      title={t('periodicPayBackTermAmount.title')}
      content={t('periodicPayBackTermAmount.content')}
      buttonHref={t('periodicPayBackTermAmount.buttonLink.href')}
      buttonText={t('periodicPayBackTermAmount.buttonLink.text')}
      label={t('periodicPayBackTermAmount.singleAmountLabel')}
      heroImage={{
        value: {
          src: `${getStaticPrefix()}/images/${label}/meterreadings/${t('periodicPayBackTermAmount.imageSrc')}`,
        },
      }}
    />
  );
};
